<template>
  <div class="activity">
    <div class="activity__wrapper">
      <div class="activity__title">
        <TitleBlock text="Activity" :size="'small'" color="brightblue" />
      </div>
      <div class="activity__content">
        <div class="row">
          <div class="column column--1-3">
            <div class="activity__left-col">
              <div class="activity__global-updates">All Global Updates</div>
              <div class="activity__counter">
                {{ count }}
              </div>
              <div class="activity__days">Last {{ period }} Days</div>
            </div>
          </div>
          <div class="column column--2-3">
            <div class="activity__right-col">
              <div class="activity__most-active">
                Your most active jurisdictions
              </div>
              <div class="flags">
                <!-- countries -->
                <div class="activity__countries">
                  <div
                    v-for="country in jurisdictions.slice(0, 6)"
                    :key="country.tid"
                    class="activity__country"
                    @click="onCountryClick(country.tid)"
                  >
                    <el-badge
                      :value="country.count"
                      :max="100"
                      class="activity__badge"
                      :title="country.name"
                    >
                      <Country
                        :iso="country.iso ? country.iso : null"
                        :link="
                          country.field_disable === 0
                            ? country.link + '/' + country.name
                            : null
                        "
                        :not-active="country.field_disable !== 0"
                        :access="country.product_access"
                        size="small"
                        :icon="country.flagurl"
                      />
                    </el-badge>
                  </div>
                </div>
                <!-- /countries -->
              </div>
              <div class="activity__active-days">
                Last {{ periodJurisdictions }} days
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Activity",
  components: {
    TitleBlock: () => import("../../components/elements/TitleBlock"),
    Country: () => import("../../components/elements/Country"),
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    jurisdictions: {
      type: Array,
      default: null,
    },
    period: {
      type: String,
      default: null,
    },
    periodJurisdictions: {
      type: String,
      default: null,
    },
  },
  methods: {
    onCountryClick(id) {
      const filterQuery = `&filter[jurisdictions][]=${id}&`;
      this.$emit("filterChanged", {
        queryParams: filterQuery,
        licenses: null,
        products: null,
        categories: null,
        jurisdictionId: id,
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.activity {
  &__title {
    background-color: $lighterBrightBlue;
  }
  &__content {
    background-color: $lighterBrightBlue;
    height: auto;
  }
  &__left-col {
    text-align: center;
    padding: 1rem;
  }
  &__right-col {
    text-align: center;
    padding: 1rem;
  }

  &__global-updates {
    font-size: 1.3rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__most-active {
    text-transform: uppercase;
    font-size: 1.3rem;
    font-weight: 700;
  }

  &__active-days {
    text-transform: uppercase;
    font-size: 1.3rem;
  }

  &__counter {
    font-size: 3rem;
    font-weight: 0.9rem;
    color: $corporateBlue;
    padding: 0.9rem;
  }

  &__days {
    font-size: 1.3rem;
    text-transform: uppercase;
  }

  &__badge {
    margin: 0.8em;
    // background-color: #e2d6b2;
    // color: #6f5c24;
  }
}

.is-fixed {
  background-color: #e2d6b2;
  color: #6f5c24;
}

.activity {
  // padding-top: 0.2rem;
  &__nav-links {
    border-bottom: 1px solid $border;
    ul {
      display: flex;
      height: 4rem;
      justify-content: center;
      align-items: center;
      li {
        margin: 0 2rem;
        a {
          font-size: 1.4rem;
          color: $text;
          text-transform: uppercase;
          cursor: pointer;
          transition: 0.3s ease-out;
          text-decoration: none;
          &:hover {
            color: $red;
          }
        }
      }
    }
  }
  &__content {
    // margin-top: 4rem;

    .accordion:not(:last-of-type) {
      margin-bottom: 2rem;
    }
    .accordion.full .el-collapse-item {
      border: none;
      &__header {
        background: $dark_blue;
      }
      &__content {
        padding-right: 0;
      }
    }
  }
  &__countries {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -3.2rem;

    justify-content: center;
    align-items: center;

    @include below($lg) {
      margin-top: 2rem;
      margin-bottom: -1.2rem;
    }
  }
  &__country {
    cursor: pointer;
    margin-bottom: 3.2rem;

    @include below($lg) {
      width: 100%;
      margin-bottom: 1.2rem;
    }
    &.full {
      width: 100%;
      & > div {
        display: flex;
        flex-wrap: wrap;
        margin-top: 2rem;
        margin-bottom: -2rem;
        @include below($lg) {
          margin-bottom: -1.2rem;
          padding-left: 1rem;
        }
        &.country__wrapper {
          margin-bottom: 0;
        }
        .country__wrapper {
          width: calc(100% / 6);
          margin-bottom: 2rem;
          @include below($lg) {
            width: 100%;
            margin-bottom: 1.2rem;
          }
        }
      }
    }
  }
}

.activity .el-badge {
  &__content {
    background-color: $brightGreen !important;
    color: white !important;
  }
}
</style>
